import { trustPages } from './trustPages';

export default {
  title: 'Trusts',
  pages: trustPages,
};
